import constants from "../utils/constants.js";
import Interceptor from "./Interceptor";

export class RequestAutomation {
    static COMMENT = "/comment";
    static INTERACTION = "/interaction";

    axios = Interceptor.getInstance();
    api_url = constants.url_api_automation();

    async getAutomation() {
        try {
            return await this.axios.get(this.api_url);
        } catch (error) {
            console.error(error);
        }
    }

    async deleteAutomation(idAutomation) {
        try {
            return await this.axios.delete(this.api_url + "?idAutomation=" +idAutomation);
        } catch (error) {
            console.error(error);
        }
    }

    async dcaAutomation(symbole, quantite,frequence,transactionType){
        try {
            return await this.axios.post(this.api_url + "/dca",{
                "symbole":symbole,
                "quantite":quantite,
                "frequence": frequence,
                "transactionType": transactionType
            });
        } catch (error) {
            throw error;
        }
    }

    async pricethresholdAutomation(ticker,thresholdPrice,transactionType,thresholdType,quantity){
        try {
            return await this.axios.post(this.api_url + "/pricethreshold",
                {
                    "ticker": ticker,
                    "thresholdPrice" : thresholdPrice,
                    "transactionType" : transactionType,
                    "thresholdType" : thresholdType,
                    "quantity" : quantity
                });
        } catch (error) {
            throw error;
        }
    }


}